module.exports = __webpack_public_path__ + "static/img/slider-rev1.e689d786.jpg";